/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Prompt_RewardInputs */

const en_check_in_prompt_reward = /** @type {(inputs: Check_In_Prompt_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt pack`)
};

const es_check_in_prompt_reward = /** @type {(inputs: Check_In_Prompt_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack de prompts`)
};

/**
* | output |
* | --- |
* | "Prompt pack" |
*
* @param {Check_In_Prompt_RewardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_prompt_reward = /** @type {((inputs?: Check_In_Prompt_RewardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Prompt_RewardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_prompt_reward(inputs)
	return es_check_in_prompt_reward(inputs)
});